
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop-wishlist",
      function () {
        return require("private-next-pages/shop-wishlist.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop-wishlist"])
      });
    }
  